module.exports = __webpack_public_path__ + "img/his-and-hers.1c1d8f3f.jpeg";